import '@/styles/titlemanager-layout.css';
import '@/styles/battlepass-layout.css';
import { useState } from 'react';
import { IngameFlash, useIngameFlash } from '@/components/IngameFlash';
import { SimpleMenu } from '@/components/MenuGrid';
import { useLocale } from '@/context/LocaleContext';
import { IconTab } from './IconTab';
import { TagTab } from './TagTab';
import { TitleTab } from './TitleTab';
import { NameTab } from './NameTab';

type TabId = 'title-tab' | 'icon-tab' | 'tag-tab' | 'name-tab';

export function TitleManagerPage() {
  const { t } = useLocale();
  const [activeTab, setActiveTab] = useState<TabId>('title-tab');
  const { flash, showFlash } = useIngameFlash(3000);

  const tabs: { id: TabId; label: string; icon: string }[] = [
    { id: 'title-tab', label: t('tm_tab_title'), icon: 'fa-crown' },
    { id: 'icon-tab', label: t('tm_tab_icon'), icon: 'fa-icons' },
    { id: 'tag-tab', label: t('tm_tab_tag'), icon: 'fa-tag' },
    { id: 'name-tab', label: t('tm_tab_name'), icon: 'fa-palette' },
  ];

  return (
    <div className="container-ingame fade-in">
      <IngameFlash flash={flash} />

      <div className="titlemanager-container">
        <SimpleMenu title={t('title_manager')}>

        <div className="titlemanager-tabs">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              type="button"
              className={`titlemanager-tab-btn${activeTab === tab.id ? ' active' : ''}`}
              data-tab={tab.id}
              aria-pressed={activeTab === tab.id}
              aria-controls={tab.id}
              onClick={() => setActiveTab(tab.id)}
            >
              <i className={`fas ${tab.icon}`} aria-hidden />
              {tab.label}
            </button>
          ))}
        </div>
        </SimpleMenu>

        <div className="titlemanager-tab-content">
          <div className={`titlemanager-tab-pane${activeTab === 'name-tab' ? ' active' : ''}`} id="name-tab">
            {activeTab === 'name-tab' ? <NameTab onNotify={showFlash} /> : null}
          </div>
          <div className={`titlemanager-tab-pane${activeTab === 'title-tab' ? ' active' : ''}`} id="title-tab">
            {activeTab === 'title-tab' ? <TitleTab onNotify={showFlash} /> : null}
          </div>
          <div className={`titlemanager-tab-pane${activeTab === 'icon-tab' ? ' active' : ''}`} id="icon-tab">
            {activeTab === 'icon-tab' ? <IconTab onNotify={showFlash} /> : null}
          </div>
          <div className={`titlemanager-tab-pane${activeTab === 'tag-tab' ? ' active' : ''}`} id="tag-tab">
            {activeTab === 'tag-tab' ? <TagTab onNotify={showFlash} /> : null}
          </div>
        </div>
      </div>
    </div>
  );
}
